import React, { FC, useEffect } from 'react';
import clsx from 'clsx';
import { WarningWithTriangle } from '@td-client-frontend/icons';
import { Spinner } from '@td-client-frontend/common';
import {
  useMarketingProfileAffectedGroups,
  ProfileType,
  useDownloadAffectedGroups
} from '../../../hooks/useMarketingProfile';

interface Props {
  id: string;
  type: ProfileType;
  hideDescription?: boolean;
  onChange?(state: number | null): void;
  onLoadingStateChange?: (x: boolean) => void;
  profileName?: string;
}

export const AffectedGroups: FC<Props> = ({
  id,
  type,
  hideDescription = false,
  onChange,
  onLoadingStateChange,
  profileName = ''
}) => {
  const { data: affectedGroups, isLoading } = useMarketingProfileAffectedGroups(id, type);
  const downloadCSV = useDownloadAffectedGroups();

  useEffect(() => {
    if (onChange) onChange(!isLoading ? affectedGroups || 0 : null);
  }, [isLoading, affectedGroups, onChange]);

  useEffect(() => {
    onLoadingStateChange?.(isLoading);
  }, [isLoading, onLoadingStateChange]);

  return (
    <div data-testid="affected-groups">
      {!isLoading ? (
        <>
          <p className="flex mb-4 text-gray-60 text-lg ">
            <WarningWithTriangle className="mr-2" />
            {affectedGroups} group(s) are affected by this change.
            <button className="text-blue-600 ml-2" onClick={() => downloadCSV(id, type, profileName)}>
              Download CSV
            </button>
          </p>
          <p className={clsx('text-lg text-gray-45', hideDescription && 'hidden')}>
            Any changes to this profile will also affect these group(s).
          </p>
        </>
      ) : (
        <>
          <div className="flex mt-4">
            <span className="mr-2">
              <Spinner />
            </span>
            Finding affected groups...
          </div>
        </>
      )}
    </div>
  );
};
